import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import LabelDetails from './../label-details/labelDetails';

import Style from './seatingCard.module.css';

export default function SeatingCard({ className = '', booking = null, title = null, event }) {
    const { t } = useTranslation();

    if (!booking || event.isUseSessionsNoSeated() || event.isFakeSeating()) {
        return null;
    }

    return (
        <div className={`${Style['container']} ${className}`}>
            {title && <div className={Style['title']}>{title}</div>}
            <LabelDetails.Container>
                <LabelDetails title={t('ticket.common.seating.category')}>
                    <div className={Style['medium']}>{booking.rate_category_name}</div>
                </LabelDetails>
                {!booking.seat_uuid && booking.area_zone ? (
                    <LabelDetails title={t('ticket.common.seating.areaZone')}>
                        <div className={Style['medium']}>{booking.area_zone_name}</div>
                    </LabelDetails>
                ) : (
                    <>
                        <LabelDetails title={t('ticket.common.seating.seat')}>
                            <div className={Style['medium']}>{booking.seat_seat}</div>
                        </LabelDetails>
                        <LabelDetails title={t('ticket.common.seating.row')}>
                            <div className={Style['medium']}>{booking.seat_row}</div>
                        </LabelDetails>
                        <LabelDetails title={t('ticket.common.seating.access')}>
                            <div className={Style['medium']}>{booking.seat_access}</div>
                        </LabelDetails>
                        <LabelDetails title={t('ticket.common.seating.zone')}>
                            <div className={Style['medium']}>{booking.seat_zone_name}</div>
                        </LabelDetails>
                        {/*<LabelDetails title={t('ticket.common.seating.grandstand')}>*/}
                        {/*<div className={Style['medium']}>{booking.seat_zone_name}</div>*/}
                        {/*</LabelDetails>*/}
                    </>
                )}
            </LabelDetails.Container>
        </div>
    );
}

SeatingCard.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    booking: PropTypes.object
};
